module.exports = __webpack_public_path__ + "img/BAR 01.e67d3b24.png";